import {type FC, useEffect} from 'react';

import {envManager} from '@yourcoach/shared/utils/env';
import {
  emitter,
  WS_RECEIVE_MESSAGE_EVENT,
} from '@yourcoach/shared/utils/eventEmitter';
import {useWS} from '@yourcoach/shared/utils/hooks';
import {getWsTraceData} from '@yourcoach/shared/utils/hooks/useWS';
import {toWsUrl} from '@yourcoach/shared/utils/wsUrl';
import {createTrace} from '@yourcoach/trace';

const traceWs = createTrace('ws');

const GET_WS_URL = () => {
  const apiEndpoint = envManager.isCore
    ? process.env.API_ENDPOINT
    : process.env.B2B_API_ENDPOINT;

  return `${toWsUrl(apiEndpoint)}/events/listen`;
};

const WS: FC = () => {
  const {lastWsMessage, lastWsMessageSeq} = useWS(GET_WS_URL());

  useEffect(() => {
    if (lastWsMessage) {
      traceWs('emit', getWsTraceData(lastWsMessage, lastWsMessageSeq));
      emitter.emit(WS_RECEIVE_MESSAGE_EVENT, lastWsMessage);
    }
  }, [lastWsMessage, lastWsMessageSeq]);

  return null;
};

export default WS;
